import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('twofactor_authentication_setup'),
    title: defineMessage('we_emailed_a_verificati_o_the_following_address'),
    changeEmailButton: defineMessage('change_the_address'),
    description: defineMessage('enter_the_verification__ternative_email_address'),
    codeFieldTitle: defineMessage('verification_code'),
    wrongCode: defineMessage('wrong_code'),
    emailCodePlaceholder: defineMessage('enter_the_verification_code_1'),
    resendCodeButton: defineMessage('resend_the_code'),
    nextButton: defineMessage('confirm_the_code'),
};
